import React, {Component} from 'react';
import './CertifiedAccreditationsList.css';
import PropTypes from 'prop-types';
import {Table} from 'reactstrap';
import _ from 'lodash';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import CertifiedAccreditationModal from './../certifiedAccreditationModal/CertifiedAccreditationModal.container';
import RemoveCertifiedAccreditationModal from './../certifiedAccreditationModal/RemoveCertifiedAccreditationModal.container';
import moment from 'moment';
import {Utils} from "../../../utils/utils";
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';

class CertifiedAccreditationsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAccreditationId: null
        };
    }

    componentDidMount() {
        this.props.onGetAccreditations();
    }

    render() {
        return (
            <div className='certified-accreditations-list-container'>
                <FormWrapper successMessage={_.get(this.props.translation, 'applicant_accreditations_management.remove_accreditation_success_massage')} hideOverlay>
                    <h4 className="page-label">{_.get(this.props.translation, 'applicant_accreditations_management.certified_accreditations_label')}</h4>
                    {this.renderContent()}
                    <CertifiedAccreditationModal
                        id={this.state.currentAccreditationId}
                    />
                    <RemoveCertifiedAccreditationModal
                        id={this.state.currentAccreditationId}
                    />
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="certified-accreditations-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="certified-accreditations-status-message-container">
                    <h6>
                        {Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'applicant_accreditations_management.no_data_label_part_1'))}
                        {_.get(this.props.translation, 'applicant_accreditations_management.no_data_label_part_2')}
                        <a className='olive-green' href='http://www.brainchainmission.org' target='_blank' rel="noopener noreferrer">
                            {_.get(this.props.translation, 'applicant_accreditations_management.no_data_label_part_3')}
                        </a>
                        {_.get(this.props.translation, 'applicant_accreditations_management.no_data_label_part_4')}
                    </h6>
                </div>
            );
        }

        return [
            <div className="responsive-header" key="header">
                <span className="accreditation-expose-responsive-header">{_.get(this.props.translation, 'applicant_accreditations_management.expose_certified_accreditations')}</span>
            </div>,
            <Table className='certified-accreditations-list-table' cellSpacing="0" key="table">
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'accreditation.accreditation_title_orig_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation.accreditation_title_en_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation.date_issued_label')}</th>
                    <th>{_.get(this.props.translation, 'applicant_accreditations_management.issued_by_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation.level_label')}</th>
                    <th className="accreditation-expose-header">{_.get(this.props.translation, 'applicant_accreditations_management.expose_certified_accreditations')}</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderAccreditationsData()}
                </tbody>
            </Table>
        ];
    };

    renderAccreditationsData() {
        return _.map(this.props.data, (accreditation, index) => (
            <tr key={accreditation.id} className="certified-accreditations-list-row">
                <td
                    className='certified-accreditation-title-original-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.accreditation_title_orig_label') + ":"}>
                    {accreditation.titleOriginal}
                </td>
                <td
                    className='certified-accreditation-title-en-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.accreditation_title_en_label') + ":"}>
                    {accreditation.titleEn}
                </td>
                <td
                    className='certified-accreditation-date-issued-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.date_issued_label') + ":"}>
                    {moment(accreditation.dateIssued).format("L")}
                </td>
                <td
                    className='certified-accreditation-issued-by-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'applicant_accreditations_management.issued_by_label') + ":"}>
                    {accreditation.issuedByName + ', ' + _.get(this.props.translation, 'countries.' + accreditation.issuedByCountry)}
                </td>
                <td
                    className='certified-accreditation-level-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.level_label') + ":"}>
                    {_.get(this.props.translation, 'levels.' + accreditation.level)}
                </td>
                <td
                    className="accreditation-expose-icon-container"
                    data-th={_.get(this.props.translation, 'applicant_accreditations_management.expose_certified_accreditations') + ":"}>
                    <IconContainer
                        className="accreditation-expose-icon"
                        icon={"check_box" + (!accreditation.expose ? "_outline_blank" : "")}
                        key={"accreditation-expose-" + accreditation.id}
                        onClick={this.onExposeClick(accreditation.id, accreditation)}
                        title={_.get(this.props.translation, 'applicant_accreditations_management.expose_certified_accreditations')}
                    />
                </td>
                <td className='certified-accreditation-visibility-icon-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}>
                    <IconContainer
                        icon='visibility'
                        key={index}
                        className='certified-accreditation-visibility-icon'
                        title={_.get(this.props.translation, 'applicant_accreditations_management.show_details_label')}
                    />
                </td>
                <td className='remove-accreditation-icon-td' onClick={this.handleRemoveIconClick(accreditation.id)}>
                    <IconContainer icon='trash'
                                   key={accreditation.id + '-trash'}
                                   className="trash-accreditation-icon"
                                   title={_.get(this.props.translation, 'accreditation_requests.remove_accreditation_request_label')}/>
                </td>
            </tr>
        ));
    }

    handleRemoveIconClick = (id) => () => {
        this.setState({currentAccreditationId: id});
        this.props.onRemoveAccreditation();
    }

    onShowAccreditationDetails = (id) => () => {
        this.setState({currentAccreditationId: id});
        this.props.onOpenAccreditationDetailsModal();
    };

    onExposeClick = (id, accreditation) => () => {
        let data = {
            expose: !accreditation.expose
        };

        this.props.onChangeExpose(id, data);
    };
}

CertifiedAccreditationsList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onGetAccreditations: PropTypes.func.isRequired,
    onChangeExpose: PropTypes.func.isRequired,
    onOpenAccreditationDetailsModal: PropTypes.func.isRequired,
    onRemoveAccreditation: PropTypes.func.isRequired
};

export default CertifiedAccreditationsList;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/certifiedAccreditationsList/CertifiedAccreditationsList.js